import React from "react";
import styles from "./ProductItem.module.scss";
import classNames from "classnames/bind";
import { Link } from "react-router-dom";

import { Heart } from "lucide-react";
import { useLanguageStore } from "../../stores/Language/useLanguageStore";
import useWishlistStore from "../../stores/WishList/WishListStore";

import { calculateDiscountPercentage } from "../../utils/priceUtils";
import Images from "../../asset/images";
const cx = classNames.bind(styles);

function ProductItem({
  srcImage,
  productText,
  textType = "name",
  price,
  className,
  onClick,
  href,
  id,
  price_sale,
  isShowHeart = true,
  ...otherProps
}) {
  const { formatPrice } = useLanguageStore();
  const { toggleWishlist, isInWishlist } = useWishlistStore();


  const isFavorite = isInWishlist(id);

  // Calculate discount percentage using utility function
  const discountPercentage = calculateDiscountPercentage(price, price_sale);

  const classes = cx("container-product", {
    [className]: className,
    item: textType === "name",
  });

  // Handle heart click
  const handleHeartClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    toggleWishlist(id, {
      id,
      product_id: id,
      name: productText || `Product ${id}`,
      slug: href?.split("/").pop() || "",
      image: srcImage ? srcImage.replace("-300x300", "") : "",
      price: Number(price_sale || price || 0),
      regular_price: Number(price || 0),
      sale_price: Number(price_sale || 0),
    });
  };

  return (
    <Link className={classes} onClick={onClick} to={href} {...otherProps}>
      <div className={cx("product-image")}>
        {/* Discount badge */}
        {discountPercentage && discountPercentage > 0 && (
          <div className={cx("discount-badge")}>-{discountPercentage}%</div>
        )}

        {/* Heart icon */}
        {isShowHeart && (
          <button
            className={cx("heart-button", { favorite: isFavorite })}
            onClick={handleHeartClick}
            aria-label={
              isFavorite ? "Remove from favorites" : "Add to favorites"
            }
            type="button"
          >
            <Heart />
          </button>
        )}

        <div className={cx("img")}>
          <img
            loading="lazy"
            src={
              srcImage ? srcImage.replace("-300x300", "") : Images.ErrorImage
            }
            alt={productText}
            onError={(e) => {
              e.target.onerror = null; // Ngăn lặp vô hạn nếu ảnh fallback cũng lỗi
              e.target.src = Images.ErrorImage;
            }}
          />
        </div>
      </div>

      <div className={cx("product-info")}>
        <div
          className={cx("product", textType === "title" ? "title" : "name")}
          title={productText}
        >
          {productText}
        </div>

        {price && (
          <div className={cx("product-price")}>
            {price_sale ? (
              <>
                <span className={cx("price-sale")}>
                  {formatPrice(price_sale)}
                </span>
                <span className={cx("price-original")}>
                  {formatPrice(price)}
                </span>
              </>
            ) : (
              <span className={cx("price-regular")}>{formatPrice(price)}</span>
            )}
          </div>
        )}
      </div>
    </Link>
  );
}

export default ProductItem;
